const appendParam = (searchParams, key, object) => {
  if (typeof object === 'object') {
    assignParams(searchParams, key, object);
  } else {
    searchParams.append(key, object);
  }
};

const assignParams = (searchParams, suffix, object) => {
  for (const property in object) {
    const value = object[property];
    const key = suffix ? `${suffix}[${property}]` : property;
    switch (true) {
      case Array.isArray(value):
        value.forEach((item) => appendParam(searchParams, `${key}[]`, item));
        break;
      default:
        appendParam(searchParams, key, value);
    }
  }
};

/**
 * Build a rails-compatible query string. For some reason @rails/request.js does not
 * work well with arrays or nested objects, so we are handling it with this method.
 *
 * @example
 *   buildSearchParams({ ids: [1, 2] }).toString() // => "ids[]=1&ids[]=2"
 *
 * @param {Array|Object} object
 * @return {URLSearchParams}
 */
const buildSearchParams = (object) => {
  const searchParams = new URLSearchParams();
  assignParams(searchParams, null, object);
  return searchParams;
};

export default buildSearchParams;
